<template>
  <div>
    <form @submit.prevent="submit()">      
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="text" 
            :name="'titulo'"
            v-model="formulario.titulo" 
            :placeholder="'Nome'"
            data-vv-as="Nome"
            v-validate="'required|max:255'"
            :error="validationErrors.first('titulo')"
         />
        </div>
      </div>
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <SGPFormInputComponent 
            type="text" 
            :name="'url'"
            v-model="formulario.url" 
            :placeholder="'Url'"
            data-vv-as="Url"
            v-validate="'required|max:255'"
            :error="validationErrors.first('url')"
         />
        </div>
      </div>
       <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
            <SGPFormSelectComponent 
                :name="'metodo'"
                :listaDeOptions="metodosHttp"
                v-model="formulario.metodo"
                data-vv-as="Método"
                :placeholder="'Método'"
                v-validate="'required'"
                :error="validationErrors.first('metodo')"
            />
        </div>
      </div>
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">          
            <SGPFormSelectComponent 
                :name="'acl_modulo_id'"
                :listaDeOptions="listaDeModulos"
                v-model="formulario.acl_modulo_id"
                :optionLabel="'modulo'"
                data-vv-as="Módulo"
                :placeholder="'Módulo'"
                v-validate="'required'"
                :error="validationErrors.first('acl_modulo_id')"                
                @change="getTextoModulo"
            />
        </div>
      </div>
      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <FormulateInput
            :class="validationErrors.first('corpoString') ? 'border border-danger' : ''"
            type="textarea"
            v-model="corpoString" 
            placeholder="Campos"
            data-vv-as="Campos"
            name="corpoString"
            v-validate="'required'"
            rows="8"
          />  
          <span class="invalid-feedback d-block">{{ validationErrors.first('corpoString') }}</span>
        </div>
      </div>

      <div class="mdn-Row">
        <div class="mdn-Col-xs mdn-u-marginTop--xs">
          <div class="container-botoes">
            <button class="v-btn v-btn--has-bg v-btn--rounded theme--light v-size--default primary text-capitalize" type="submit">
              {{ tipoFormulario === 'salvar' ? 'Salvar' : 'Atualizar' }}
            </button>
            <button class="v-btn v-btn--outlined v-btn--rounded theme--light v-size--default grey-5--text text-capitalize" type="button" @click="fecharModal()">Cancelar</button>
          </div>
        </div>
      </div>      
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "FormularioFormComponent",

  props: {
    tipoFormulario: {
      type: String,
      required: false,
      default: 'salvar'
    },
    formDinamico: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      formulario: this.$props.formDinamico || {
        titulo: '',
        url: '',
        metodo: '',
        acl_modulo_id: ''
      },
      corpoString: this.$props.formDinamico ? JSON.stringify(this.$props.formDinamico.corpo): '',
      metodosHttp: [
        { name: 'get', id: 'get'},
        { name: 'post', id: 'post'},
        { name: 'put', id: 'put'},
        { name: 'delete', id: 'delete'}
      ]
    }
  },
  created () {
    this.listarModulos()
  },
  computed: {
    ...mapGetters('tiposStatus', [
      'listaDeTiposStatus']),
    ...mapGetters('modulos', [
      'listaDeModulos'])
  },
  methods: {
    ...mapActions('formularios', [
      'salvarFormulario',
      'buscarStatus',
      'atualizarFormulario'
    ]),
    ...mapActions('modulos', [
      'listarModulos'
    ]),
     validate: function () {
        this.$validator.validateAll();
     },
     limparCampos () {
      this.formulario.titulo = '';
      this.formulario.url = '';
      this.formulario.metodo = '';
      this.formulario.modulo = '';
      this.corpoString = '';
      this.$validator.reset();
     },  
     getTextoModulo(v) {
      //let moduloName = this.listaDeModulos.filter(modulo => modulo.id == v)[0].modulo
      this.formulario.moduloName = this.listaDeModulos.filter(modulo => modulo.id == v)[0].modulo      
     }, 
    submit () {
      // invoca o vee validade para a validação dos campos
       this.$validator.validateAll().then(async (result) => {
        if (result) {

          this.formulario.corpo = JSON.parse(this.corpoString);

          if(this.tipoFormulario === 'salvar') {
            const resp = await this.salvarFormulario(this.formulario);            
            if(!resp) { 
              return;
            }            
          }else{
              const resp = await this.atualizarFormulario(this.formulario);
              if(!resp){
                return;
              } 
          }

          this.limparCampos();
          this.fecharModal();
          return;
        }
      });     
       
    },

    fecharModal () {
      this.$parent.$parent.$parent.$parent.fecharModal()
    }
  }

}
</script>